import { useEffect, useState } from 'react'

import { useDebounce } from './useDebounce'

export function useResizeWindows(delay = 0) {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const debouncedWidth = useDebounce(width, delay)
  const debouncedHeight = useDebounce(height, delay)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return { width: debouncedWidth, height: debouncedHeight }
}
